import { createLogger } from "./config";

const amplitudeLogger = createLogger("Amplitude", "amplitude.ts");

/**
 * Console-log an Amplitude event payload in beautified JSON form, tagged with
 * delivery status. Intended to be called from each app's Amplitude wrapper so
 * developers can see exactly what was (or was not) sent to Amplitude.
 *
 * Logs at INFO level for "success" and ERROR level for "failure". Output is
 * silenced in production builds by the logger's default level configuration.
 *
 * @param eventName - Event name as passed to amplitude.track
 * @param payload - Full payload object sent (base envelope + additional data)
 * @param status - "success" once amplitude.track returned, "failure" on throw
 * @param error - Optional error captured in the catch branch
 */
export const logAmplitudeEvent = (
  eventName: string,
  payload: Record<string, unknown>,
  status: "success" | "failure",
  error?: unknown,
): void => {
  const message = `[Amplitude] ${eventName} — ${status.toUpperCase()}`;
  const body: Record<string, unknown> = {
    event_name: eventName,
    status,
    payload,
  };
  if (error !== undefined) {
    body.error = error instanceof Error ? error.message : error;
  }

  if (status === "success") {
    amplitudeLogger.info(message, body);
  } else {
    amplitudeLogger.error(message, body);
  }
};
